import { Country } from '../country/country';

export const FREE_SHIPPING_THRESHOLD = {
  [Country.Australia]: 55,
  [Country.Singapore]: 49,
  [Country.UnitedStates]: 49,
  [Country.Malaysia]: 170,
  [Country.Canada]: 69,
  [Country.NewZealand]: 60,
  // [Country.Qatar]: 215,
  [Country.UnitedArabEmirates]: 180,
  [Country.SaudiArabia]: 220,
  [Country.UnitedKingdom]: 45,
  [Country.Netherlands]: 45,
  [Country.Germany]: 45,
  [Country.France]: 45,
  //[Country.Spain]: 45,
  [Country.Belgium]: 45,
  [Country.Mexico]: 800,
  [Country.Chile]: 54000,
  [Country.Colombia]: 166000,
};
